import React from 'react';
import { Alert, Link, Typography } from '@one-thd/sui-atomic-components';
import { useInstantCheckout } from '../../../hooks/use-instant-checkout';
import { TAlertType } from '../../../models/common/alert-messages';
import { track } from '../../../utils/analytics';
import { INSTANT_CHECKOUT_CONTINUE_SHOPPING_LINK } from '../../../constants/analytics';
import { useSearchParam } from '../../../hooks/use-search-param';
export const InstantCheckoutAlert = () => {
    const { alertMessage, setAlertMessage } = useInstantCheckout();
    const isUpdateMessage = (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.alertType) === TAlertType.IC_ADDRESS_UPDATE ||
        (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.alertType) === TAlertType.IC_PAYMENT_UPDATE;
    const setContinueShoppingAnalytics = () => {
        switch (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.alertType) {
            case TAlertType.IC_ADDRESS_UPDATE:
                track(INSTANT_CHECKOUT_CONTINUE_SHOPPING_LINK, 'delivery address');
                break;
            case TAlertType.IC_PAYMENT_UPDATE:
                track(INSTANT_CHECKOUT_CONTINUE_SHOPPING_LINK, 'payment method');
                break;
            default:
                track(INSTANT_CHECKOUT_CONTINUE_SHOPPING_LINK, 'unknown');
        }
    };
    const icReferrer = useSearchParam('icReferrer');
    const referrerUrl = icReferrer && new URL(icReferrer, window.location.origin).href;
    const showContinueShoppingLink = isUpdateMessage && Boolean(icReferrer);
    return (React.createElement(React.Fragment, null, (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.alertStatus) === 'error' ? (React.createElement(Alert, { status: alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.alertStatus }, (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.text) && React.createElement(Typography, null, alertMessage.text))) : (React.createElement(Alert, { status: alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.alertStatus, onClose: () => setAlertMessage(null) }, (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.text) && (React.createElement(Typography, null,
        alertMessage.text,
        showContinueShoppingLink && (React.createElement(Link, { component: "button", onClick: setContinueShoppingAnalytics, href: referrerUrl }, "Continue Shopping"))))))));
};
